module.exports = __webpack_public_path__ + "static/media/pin (5).3b53175c.png";